import 'tsdi-multi-scope';
import 'whatwg-fetch';
import '@tools/analytics-scripts/facebook-pixel-setup';

import { configure } from 'mobx';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { TSDI } from 'tsdi';

import { App } from './app';

configure({
    enforceActions: 'never'
});

const tsdi = new TSDI();

tsdi.enableComponentScanner();

const container = document.getElementById('app')!;
const root = createRoot(container);

root.render(<App />);
